import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as backInter from 'app/auth/auth-data.model';
import { DATOS_API } from 'app/auth/auth.datos';
/// SERVICIO DE AUTENTICACION
import { AuthService } from 'app/auth/auth.service';

import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CierreService {

  idEmpresa: string;
  idUsuario: string;
  idInstituto: string;

  private mensajeOrigen = new BehaviorSubject('');
  mensajeActual = this.mensajeOrigen.asObservable();

  constructor(
    private http:HttpClient,
    private authService:AuthService
  ) {
    if(this.authService.getIsAuth()){
      this.obtienInfo();
    }
  }
  obtienInfo()
  {
    this.idUsuario = this.authService.getIdUsuario();
    this.idInstituto = this.authService.getInstituto();
    let infoUsu: backInter.infoUsuario = this.authService.getInfoUsuario();
    // console.log(infoUsu);
    this.idEmpresa = infoUsu.empresaId;
  }

  puenteDatos(mensaje: string) {
    this.mensajeOrigen.next(mensaje);
  }

  getProdCertAct(){
    this.obtienInfo();
    if(this.idEmpresa == '0' && localStorage.getItem('Surveystaus_portal')== "activo"){
      this.idEmpresa=localStorage.getItem('idEmpresa_surveysatus');
    }
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.productos + this.idEmpresa);
  }

  getStatusCierre(productoId: any){
    this.obtienInfo();
    let datos: any = {productoId,	close: 1};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getStatusPart + this.idEmpresa, datos);
  }

  guardaStatusCierre(productoId: any){
    this.obtienInfo();
    let datos: any = {productoId,	close: 3};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.guardaStatus + this.idEmpresa, datos);
  }
  //Cierre Medir
  getStatusCierreMedir(anio: string){
    this.obtienInfo();
    let datos: any = {productoId: anio,	close: 1};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.medir.getStatusPart + this.idEmpresa, datos);
  }

  guardaStatusCierreMedir(anio:string){
    this.obtienInfo();
    let datos: any = {productoId: anio,	close:  3};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.medir.guardaStatus + this.idEmpresa, datos);
  }

  getFechasProgramacionPulse(anio: any){
    this.obtienInfo();
    let datos: any = {productoId: anio};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.pulse.getFecha + this.idEmpresa, datos);
  }

  getFechasProgramacionPulse_status(anio: any,idEmpresa){
    let datos: any = {productoId: anio};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.pulse.getFecha + idEmpresa, datos);
  }

   getProgressEncPulse(productoId:string){
     this.obtienInfo();
     let datos : any ={productoId};
     return this.http.post(DATOS_API.url + DATOS_API.endpoints.pulse.getProgressEnc+this.idEmpresa,datos);
      // return this.httpClient.post
    }

    getProgressEncPulse_status(productoId:string,idEmpresa){
      let datos : any ={productoId};
      return this.http.post(DATOS_API.url + DATOS_API.endpoints.pulse.getProgressEnc+idEmpresa,datos);
       // return this.httpClient.post
     }

  getStatusCierrePulse(anio: string){
    this.obtienInfo();
    let datos: any = {productoId: anio,	close: 1};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.pulse.getStatusPart + this.idEmpresa, datos);
  }
  guardaStatusCierrePulse(anio:string){
    this.obtienInfo();
    let datos: any = {productoId: anio,	close:  3};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.pulse.guardaStatus + this.idEmpresa, datos);
  }
//portal conteos
  saveConteosClaves(datos){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.saveConteosClave,datos);
    }
  getConteosClave(clave: any ){
    let datos:any={};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getConteosClave+clave,datos);
    }
  getClaveConteos(datos: any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getClaveConteo,datos);
  }
  getClavesConteosPulse(datos: any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getClavesConteosPulse,datos);
  }

  sendRecordatorioMedir(idProducto){
    this.obtienInfo();
    let datos: any = {productoId: idProducto};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.medir.sendreminderMedir + this.idEmpresa, datos);
  }

  getRecordatorios_correo(datos:any){
    this.obtienInfo();
    console.log("id empresa"+this.idEmpresa);
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getemailreminder + this.idEmpresa, datos);
  }

  getRecordatorios_correo_statussurvey(datos:any,idEmpresa){
    console.log("id empresa"+this.idEmpresa);
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getemailreminder + idEmpresa, datos);
  }

  sendRecordatorioMedirGenerico(idProducto){
    this.obtienInfo();
    let datos: any = {productoId: idProducto};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.medir.sendreminderMedirGenerico + this.idEmpresa, datos);
  }

  sendRecordatorioMedirGenerico_status(idProducto,idEmpresa){
    this.obtienInfo();
    let datos: any = {productoId: idProducto};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.medir.sendreminderMedirGenerico + idEmpresa, datos);
  }

  getRecordatorios_correoGenerico(datos:any){
    this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.medir.getMedirGenerico + this.idEmpresa, datos);
  }

  getRecordatorios_correoGenerico_status(datos:any,idEmpresa){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.medir.getMedirGenerico + idEmpresa, datos);
  }


  CertificarsendRecordatorio(idProducto){
    this.obtienInfo();
    let datos: any = {productoId: idProducto};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.sendreminder + this.idEmpresa, datos);
  }

  CertificarsendRecordatorio_statusSurvey(idProducto,idEmpresa){
    let datos: any = {productoId: idProducto};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.sendreminder + idEmpresa, datos);
  }

  Certificar3sendRecordatorio_statusSurveySMTP(idProducto,idEmpresa){
    let tipos:any[]=[6,7];
    let datos: any = {productoId: idProducto, empresaId:idEmpresa,tipos:tipos};
    console.log('datos send recordatorios',datos);

    return this.http.post(DATOS_API.url + DATOS_API.endpoints.manualReminderSMTPCer3, datos);
  }

  CertificarsendRecordatorio_statusSurveySMTP(idProducto,idEmpresa){
    let datos: any = {productoId: idProducto, empresaId:idEmpresa};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.manualReminderSMTP + idEmpresa, datos);
  }
  enviaRecordatoriosManualesID_SMTP(idProducto){
    this.obtienInfo();
    let datos: any = {productoId: idProducto};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.manualReminderSMTP + this.idEmpresa, datos);
  }
  enviaRecordatoriosCer3ManualesID_SMTP(idProducto){
    this.obtienInfo();
    let tipos:any[]=[6,7];
    let datos: any = {productoId: idProducto, empresaId:this.idEmpresa,tipos:tipos};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.manualReminderSMTPCer3, datos);
  }

  enviaRecordatoriosManualesSMTP(){
    this.obtienInfo();
    let datos: any = {productoId: localStorage.getItem('productoID')};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.manualReminderSMTP + this.idEmpresa, datos);
  }

  public getFechaLanzamiento(data){
    this.obtienInfo();

    return this.http.post(DATOS_API.url + DATOS_API.endpoints.shedule.getFechaLanzamiento+this.idEmpresa,data);
    // return this.httpClient.post(this.ip+'/api_empresa/programarEncuesta/fechaLanzamiento/'+this.getCompanyID(),data,
    // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

    getRecordatoriosPulse(datos){
      this.obtienInfo();
      // let datos: any = {productoId: anio,numeroFecha,fecha};
      return this.http.post(DATOS_API.url + DATOS_API.endpoints.pulse.getRecordatoriosPulseManuales +this.idEmpresa, datos);
    }

    getRecordatoriosPulse_status(datos,idEmpresa){
      // let datos: any = {productoId: anio,numeroFecha,fecha};
      return this.http.post(DATOS_API.url + DATOS_API.endpoints.pulse.getRecordatoriosPulseManuales + idEmpresa, datos);
    }

    sendRecordatoriosPulse(datos){
      this.obtienInfo();
      // let datos: any = {productoId: anio,numeroFecha,fecha};
      return this.http.post(DATOS_API.url + DATOS_API.endpoints.pulse.sendRecordatoriosPulse + this.idEmpresa, datos);
    }

    sendRecordatoriosPulse_status(datos,idEmpresa){
      // let datos: any = {productoId: anio,numeroFecha,fecha};
      return this.http.post(DATOS_API.url + DATOS_API.endpoints.pulse.sendRecordatoriosPulse + idEmpresa, datos);
    }
//////////Focus area

    getRecordatoriosFocusArea(){
      let data=" ";
      return this.http.post(DATOS_API.url + DATOS_API.endpoints.Focus.getRecordatoriosFocusAreaManuales +localStorage.getItem('encuestaID'),data);

    }

    sendRecordatoriosFocusArea(){
  let data=" ";
      return this.http.post(DATOS_API.url + DATOS_API.endpoints.Focus.sendRecordatoriosFocusAreaManuales +localStorage.getItem('encuestaID'),data);

    }
////// GET CODE SURVEY
  getUrlCode(){
    this.obtienInfo();
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.getCodeSurv.get + this.idEmpresa + "/" + localStorage.getItem('productoID'));
  }

  getUrlCode_estatussurvey(idEmpresa, idProducto){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.getCodeSurv.get + idEmpresa + "/" + idProducto);
  }
  saveUrlCode(){
    this.obtienInfo();
    let datos:any = {
      empresaId: this.idEmpresa,
      productoId: localStorage.getItem('productoID')
    };
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getCodeSurv.save, datos);
  }


////servicio seccion Activar encuesta////
activarEstatusSurvey(datos){
  console.log("open",datos);
  this.obtienInfo();
  return this.http.post(DATOS_API.url + DATOS_API.endpoints.certificar2.seccionConfirmaEncuesta.activarEstatus + this.idEmpresa + "/" + localStorage.getItem('productoID'),datos);
}

desactivarEstatusSurvey(datos){
  console.log("close",datos);
  this.obtienInfo();
  return this.http.post(DATOS_API.url + DATOS_API.endpoints.certificar2.seccionConfirmaEncuesta.activarEstatus + this.idEmpresa + "/" + localStorage.getItem('productoID'),datos);
}

getEstatusSurvey(){
  this.obtienInfo();
  return this.http.get(DATOS_API.url + DATOS_API.endpoints.certificar2.seccionConfirmaEncuesta.getEstatusEncuesta + this.idEmpresa + "/" + localStorage.getItem('productoID'));
}



}
